import SearchModuleUtil from '@lts-web/utils/SearchModuleUtil';

export default ({
    moduleName,
    formElement,
    actionURL = '',
    defaults = {},
    inputsConvention = {},
    navigationFunction = () => {}
}) => {
    if (!SearchModuleUtil.hasModuleName(moduleName)) {
        throw new Error('Module name does not exists');
    }

    if (!(formElement instanceof Element)) {
        throw new Error('formElement must be of instance `Element`');
    }

    return {
        moduleName,
        formElement,
        actionURL,
        defaults,
        inputsConvention,
        navigationFunction
    };
};